import { render, staticRenderFns } from "./computationalFormula.vue?vue&type=template&id=4b641ca5"
import script from "./computationalFormula.vue?vue&type=script&lang=js"
export * from "./computationalFormula.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports